import React from 'react';
import InputField from '../../Shared/InputField';
import PropTypes from 'prop-types';
import {
  ABOUT_ME_FIELD_NAMES,
  getPostGraduationOptionLabel,
  POST_GRADUATION_OPTION_VALUES,
  POST_GRADUATION_OPTIONS,
} from '../../../constants/general';

import { makeStyles } from '@material-ui/core/styles';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';

const formStyles = makeStyles((theme) => ({
  rowSpacer: {
    [theme.breakpoints.up('sm')]: {
      height: 30,
    },
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  textRowSpacer: {
    paddingRight: '10px',
    paddingTop: '10px',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '5px',
    },
  },
  textRowLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      minHeight: 30,
      paddingTop: 15,
      overflow: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 30,
      paddingTop: 10,
      overflow: 'auto',
    },
  },
  radioGroupLabel: {
    paddingTop: 7,
  },
  rowSpacer50: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
    [theme.breakpoints.down('sm')]: {
      height: 50,
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
}));
const AboutMeInputFields = ({ formData, handleChange, disabled = false, version = 1 }) => {
  const formClasses = formStyles();
  const filteredPostGraduationOptions = POST_GRADUATION_OPTIONS.filter((opt) => opt.value !== POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING);
  return (
    <React.Fragment>
      {version === 2 && (
        <>
          <Grid container direction="row" align="left" className={formClasses.unprintedContent} style={{ marginTop: 10, marginBottom: 20 }}>
            <Grid item xs={12} sm={4} md={3} lg={2} className={formClasses.labelRowSpacer}>
              <InputLabel id="post_graduation_plan_selection">My post-graduation plan is</InputLabel>
            </Grid>
            <Grid item xs={11} sm={5} md={4} lg={3} className={formClasses.textRowSpacer} style={{ marginTop: -20 }}>
              <FormControl fullWidth>
                <Select
                  name="post_graduation_plan_selection"
                  labelId="post_graduation_plan_selection"
                  id="post_graduation_plan_selection"
                  value={formData.post_graduation_plan_selection}
                  onChange={handleChange}
                  disabled={disabled}
                >
                  {filteredPostGraduationOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={false} sm={3} md={5} lg={7} className={formClasses.textRowSpacer}></Grid>
          </Grid>
          <summary className={formClasses.printedContent + ' ' + formClasses.rowSpacer50}>
            My post-graduation plan is {getPostGraduationOptionLabel(formData.post_graduation_plan_selection)}.
          </summary>
        </>
      )}
      <InputField
        label={ABOUT_ME_FIELD_NAMES.planText}
        name="post_graduation_plan"
        value={formData.post_graduation_plan}
        onChange={handleChange}
        multiple={true}
        maxLength={1000}
        isDisabled={disabled}
        isRequired={true}
      />
      <InputField
        label={ABOUT_ME_FIELD_NAMES.accomplishmentText}
        name="accomplishments"
        value={formData.accomplishments}
        onChange={handleChange}
        multiple={true}
        maxLength={1000}
        isDisabled={disabled}
        isRequired={true}
      />
      <InputField
        label={ABOUT_ME_FIELD_NAMES.activityText}
        name="extracurricular_activities"
        value={formData.extracurricular_activities}
        onChange={handleChange}
        multiple={true}
        maxLength={1000}
        isDisabled={disabled}
        isRequired={true}
      />
    </React.Fragment>
  );
};

AboutMeInputFields.propTypes = {
  formData: PropTypes.shape({
    post_graduation_plan_selection: PropTypes.string,
    post_graduation_plan: PropTypes.string,
    accomplishments: PropTypes.string,
    extracurricular_activities: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  version: PropTypes.number,
};

export default AboutMeInputFields;
